// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file profile-showcase.proto (syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file profile-showcase.proto.
 */
export const file_profile_showcase: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
  )

/**
 * @generated from message ProfileShowcaseCommunity
 */
export type ProfileShowcaseCommunity = Message<'ProfileShowcaseCommunity'> & {
  /**
   * @generated from field: string community_id = 1;
   */
  communityId: string

  /**
   * @generated from field: uint32 order = 2;
   */
  order: number

  /**
   * @generated from field: bytes grant = 3;
   */
  grant: Uint8Array
}

/**
 * Describes the message ProfileShowcaseCommunity.
 * Use `create(ProfileShowcaseCommunitySchema)` to create a new message.
 */
export const ProfileShowcaseCommunitySchema: GenMessage<ProfileShowcaseCommunity> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 0)

/**
 * @generated from message ProfileShowcaseAccount
 */
export type ProfileShowcaseAccount = Message<'ProfileShowcaseAccount'> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string color_id = 3;
   */
  colorId: string

  /**
   * @generated from field: string emoji = 4;
   */
  emoji: string

  /**
   * @generated from field: uint32 order = 5;
   */
  order: number
}

/**
 * Describes the message ProfileShowcaseAccount.
 * Use `create(ProfileShowcaseAccountSchema)` to create a new message.
 */
export const ProfileShowcaseAccountSchema: GenMessage<ProfileShowcaseAccount> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 1)

/**
 * @generated from message ProfileShowcaseCollectible
 */
export type ProfileShowcaseCollectible =
  Message<'ProfileShowcaseCollectible'> & {
    /**
     * @generated from field: string uid = 1 [deprecated = true];
     * @deprecated
     */
    uid: string

    /**
     * @generated from field: uint32 order = 2;
     */
    order: number

    /**
     * @generated from field: string contract_address = 3;
     */
    contractAddress: string

    /**
     * @generated from field: string community_id = 4 [deprecated = true];
     * @deprecated
     */
    communityId: string

    /**
     * @generated from field: uint64 chain_id = 5;
     */
    chainId: bigint

    /**
     * @generated from field: string token_id = 6;
     */
    tokenId: string

    /**
     * @generated from field: string account_address = 7 [deprecated = true];
     * @deprecated
     */
    accountAddress: string
  }

/**
 * Describes the message ProfileShowcaseCollectible.
 * Use `create(ProfileShowcaseCollectibleSchema)` to create a new message.
 */
export const ProfileShowcaseCollectibleSchema: GenMessage<ProfileShowcaseCollectible> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 2)

/**
 * @generated from message ProfileShowcaseVerifiedToken
 */
export type ProfileShowcaseVerifiedToken =
  Message<'ProfileShowcaseVerifiedToken'> & {
    /**
     * @generated from field: string symbol = 1;
     */
    symbol: string

    /**
     * @generated from field: uint32 order = 2;
     */
    order: number
  }

/**
 * Describes the message ProfileShowcaseVerifiedToken.
 * Use `create(ProfileShowcaseVerifiedTokenSchema)` to create a new message.
 */
export const ProfileShowcaseVerifiedTokenSchema: GenMessage<ProfileShowcaseVerifiedToken> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 3)

/**
 * @generated from message ProfileShowcaseUnverifiedToken
 */
export type ProfileShowcaseUnverifiedToken =
  Message<'ProfileShowcaseUnverifiedToken'> & {
    /**
     * @generated from field: string contract_address = 1;
     */
    contractAddress: string

    /**
     * @generated from field: uint32 order = 2;
     */
    order: number

    /**
     * @generated from field: uint64 chain_id = 3;
     */
    chainId: bigint

    /**
     * @generated from field: string community_id = 4 [deprecated = true];
     * @deprecated
     */
    communityId: string
  }

/**
 * Describes the message ProfileShowcaseUnverifiedToken.
 * Use `create(ProfileShowcaseUnverifiedTokenSchema)` to create a new message.
 */
export const ProfileShowcaseUnverifiedTokenSchema: GenMessage<ProfileShowcaseUnverifiedToken> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 4)

/**
 * @generated from message ProfileShowcaseSocialLink
 */
export type ProfileShowcaseSocialLink = Message<'ProfileShowcaseSocialLink'> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string

  /**
   * @generated from field: uint32 order = 2;
   */
  order: number

  /**
   * @generated from field: string text = 3;
   */
  text: string
}

/**
 * Describes the message ProfileShowcaseSocialLink.
 * Use `create(ProfileShowcaseSocialLinkSchema)` to create a new message.
 */
export const ProfileShowcaseSocialLinkSchema: GenMessage<ProfileShowcaseSocialLink> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 5)

/**
 * @generated from message ProfileShowcaseEntries
 */
export type ProfileShowcaseEntries = Message<'ProfileShowcaseEntries'> & {
  /**
   * @generated from field: repeated ProfileShowcaseCommunity communities = 1;
   */
  communities: ProfileShowcaseCommunity[]

  /**
   * @generated from field: repeated ProfileShowcaseAccount accounts = 2;
   */
  accounts: ProfileShowcaseAccount[]

  /**
   * @generated from field: repeated ProfileShowcaseCollectible collectibles = 3;
   */
  collectibles: ProfileShowcaseCollectible[]

  /**
   * @generated from field: repeated ProfileShowcaseVerifiedToken verified_tokens = 4;
   */
  verifiedTokens: ProfileShowcaseVerifiedToken[]

  /**
   * @generated from field: repeated ProfileShowcaseUnverifiedToken unverified_tokens = 5;
   */
  unverifiedTokens: ProfileShowcaseUnverifiedToken[]

  /**
   * @generated from field: repeated ProfileShowcaseSocialLink social_links = 6;
   */
  socialLinks: ProfileShowcaseSocialLink[]
}

/**
 * Describes the message ProfileShowcaseEntries.
 * Use `create(ProfileShowcaseEntriesSchema)` to create a new message.
 */
export const ProfileShowcaseEntriesSchema: GenMessage<ProfileShowcaseEntries> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 6)

/**
 * @generated from message ProfileShowcaseEntriesEncrypted
 */
export type ProfileShowcaseEntriesEncrypted =
  Message<'ProfileShowcaseEntriesEncrypted'> & {
    /**
     * @generated from field: bytes encrypted_entries = 1;
     */
    encryptedEntries: Uint8Array

    /**
     * @generated from field: repeated bytes encryption_keys = 2;
     */
    encryptionKeys: Uint8Array[]
  }

/**
 * Describes the message ProfileShowcaseEntriesEncrypted.
 * Use `create(ProfileShowcaseEntriesEncryptedSchema)` to create a new message.
 */
export const ProfileShowcaseEntriesEncryptedSchema: GenMessage<ProfileShowcaseEntriesEncrypted> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 7)

/**
 * @generated from message ProfileShowcase
 */
export type ProfileShowcase = Message<'ProfileShowcase'> & {
  /**
   * @generated from field: ProfileShowcaseEntries for_everyone = 1;
   */
  forEveryone?: ProfileShowcaseEntries

  /**
   * @generated from field: ProfileShowcaseEntriesEncrypted for_contacts = 2;
   */
  forContacts?: ProfileShowcaseEntriesEncrypted

  /**
   * @generated from field: ProfileShowcaseEntriesEncrypted for_id_verified_contacts = 3;
   */
  forIdVerifiedContacts?: ProfileShowcaseEntriesEncrypted
}

/**
 * Describes the message ProfileShowcase.
 * Use `create(ProfileShowcaseSchema)` to create a new message.
 */
export const ProfileShowcaseSchema: GenMessage<ProfileShowcase> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 8)

/**
 * @generated from message ProfileShowcaseCommunityPreference
 */
export type ProfileShowcaseCommunityPreference =
  Message<'ProfileShowcaseCommunityPreference'> & {
    /**
     * @generated from field: string community_id = 1;
     */
    communityId: string

    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 2;
     */
    showcaseVisibility: ProfileShowcaseVisibility

    /**
     * @generated from field: uint32 order = 3;
     */
    order: number
  }

/**
 * Describes the message ProfileShowcaseCommunityPreference.
 * Use `create(ProfileShowcaseCommunityPreferenceSchema)` to create a new message.
 */
export const ProfileShowcaseCommunityPreferenceSchema: GenMessage<ProfileShowcaseCommunityPreference> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 9)

/**
 * @generated from message ProfileShowcaseAccountPreference
 */
export type ProfileShowcaseAccountPreference =
  Message<'ProfileShowcaseAccountPreference'> & {
    /**
     * @generated from field: string address = 1;
     */
    address: string

    /**
     * @generated from field: string name = 2 [deprecated = true];
     * @deprecated
     */
    name: string

    /**
     * @generated from field: string color_id = 3 [deprecated = true];
     * @deprecated
     */
    colorId: string

    /**
     * @generated from field: string emoji = 4 [deprecated = true];
     * @deprecated
     */
    emoji: string

    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 5;
     */
    showcaseVisibility: ProfileShowcaseVisibility

    /**
     * @generated from field: uint32 order = 6;
     */
    order: number
  }

/**
 * Describes the message ProfileShowcaseAccountPreference.
 * Use `create(ProfileShowcaseAccountPreferenceSchema)` to create a new message.
 */
export const ProfileShowcaseAccountPreferenceSchema: GenMessage<ProfileShowcaseAccountPreference> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 10)

/**
 * @generated from message ProfileShowcaseCollectiblePreference
 */
export type ProfileShowcaseCollectiblePreference =
  Message<'ProfileShowcaseCollectiblePreference'> & {
    /**
     * @generated from field: string contract_address = 1;
     */
    contractAddress: string

    /**
     * @generated from field: uint64 chain_id = 2;
     */
    chainId: bigint

    /**
     * @generated from field: string token_id = 3;
     */
    tokenId: string

    /**
     * @generated from field: string community_id = 4 [deprecated = true];
     * @deprecated
     */
    communityId: string

    /**
     * @generated from field: string account_address = 5 [deprecated = true];
     * @deprecated
     */
    accountAddress: string

    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 6;
     */
    showcaseVisibility: ProfileShowcaseVisibility

    /**
     * @generated from field: uint32 order = 7;
     */
    order: number
  }

/**
 * Describes the message ProfileShowcaseCollectiblePreference.
 * Use `create(ProfileShowcaseCollectiblePreferenceSchema)` to create a new message.
 */
export const ProfileShowcaseCollectiblePreferenceSchema: GenMessage<ProfileShowcaseCollectiblePreference> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 11)

/**
 * @generated from message ProfileShowcaseVerifiedTokenPreference
 */
export type ProfileShowcaseVerifiedTokenPreference =
  Message<'ProfileShowcaseVerifiedTokenPreference'> & {
    /**
     * @generated from field: string symbol = 1;
     */
    symbol: string

    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 2;
     */
    showcaseVisibility: ProfileShowcaseVisibility

    /**
     * @generated from field: uint32 order = 3;
     */
    order: number
  }

/**
 * Describes the message ProfileShowcaseVerifiedTokenPreference.
 * Use `create(ProfileShowcaseVerifiedTokenPreferenceSchema)` to create a new message.
 */
export const ProfileShowcaseVerifiedTokenPreferenceSchema: GenMessage<ProfileShowcaseVerifiedTokenPreference> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 12)

/**
 * @generated from message ProfileShowcaseUnverifiedTokenPreference
 */
export type ProfileShowcaseUnverifiedTokenPreference =
  Message<'ProfileShowcaseUnverifiedTokenPreference'> & {
    /**
     * @generated from field: string contract_address = 1;
     */
    contractAddress: string

    /**
     * @generated from field: uint64 chain_id = 2;
     */
    chainId: bigint

    /**
     * @generated from field: string community_id = 3 [deprecated = true];
     * @deprecated
     */
    communityId: string

    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 4;
     */
    showcaseVisibility: ProfileShowcaseVisibility

    /**
     * @generated from field: uint32 order = 5;
     */
    order: number
  }

/**
 * Describes the message ProfileShowcaseUnverifiedTokenPreference.
 * Use `create(ProfileShowcaseUnverifiedTokenPreferenceSchema)` to create a new message.
 */
export const ProfileShowcaseUnverifiedTokenPreferenceSchema: GenMessage<ProfileShowcaseUnverifiedTokenPreference> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 13)

/**
 * @generated from message ProfileShowcaseSocialLinkPreference
 */
export type ProfileShowcaseSocialLinkPreference =
  Message<'ProfileShowcaseSocialLinkPreference'> & {
    /**
     * @generated from field: string url = 1;
     */
    url: string

    /**
     * @generated from field: string text = 2;
     */
    text: string

    /**
     * @generated from field: uint32 order = 3;
     */
    order: number

    /**
     * @generated from field: ProfileShowcaseVisibility showcase_visibility = 4;
     */
    showcaseVisibility: ProfileShowcaseVisibility
  }

/**
 * Describes the message ProfileShowcaseSocialLinkPreference.
 * Use `create(ProfileShowcaseSocialLinkPreferenceSchema)` to create a new message.
 */
export const ProfileShowcaseSocialLinkPreferenceSchema: GenMessage<ProfileShowcaseSocialLinkPreference> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 14)

/**
 * @generated from message SyncProfileShowcasePreferences
 */
export type SyncProfileShowcasePreferences =
  Message<'SyncProfileShowcasePreferences'> & {
    /**
     * @generated from field: uint64 clock = 1;
     */
    clock: bigint

    /**
     * @generated from field: repeated ProfileShowcaseCommunityPreference communities = 2;
     */
    communities: ProfileShowcaseCommunityPreference[]

    /**
     * @generated from field: repeated ProfileShowcaseAccountPreference accounts = 3;
     */
    accounts: ProfileShowcaseAccountPreference[]

    /**
     * @generated from field: repeated ProfileShowcaseCollectiblePreference collectibles = 4;
     */
    collectibles: ProfileShowcaseCollectiblePreference[]

    /**
     * @generated from field: repeated ProfileShowcaseVerifiedTokenPreference verified_tokens = 5;
     */
    verifiedTokens: ProfileShowcaseVerifiedTokenPreference[]

    /**
     * @generated from field: repeated ProfileShowcaseUnverifiedTokenPreference unverified_tokens = 6;
     */
    unverifiedTokens: ProfileShowcaseUnverifiedTokenPreference[]

    /**
     * @generated from field: repeated ProfileShowcaseSocialLinkPreference social_links = 7;
     */
    socialLinks: ProfileShowcaseSocialLinkPreference[]
  }

/**
 * Describes the message SyncProfileShowcasePreferences.
 * Use `create(SyncProfileShowcasePreferencesSchema)` to create a new message.
 */
export const SyncProfileShowcasePreferencesSchema: GenMessage<SyncProfileShowcasePreferences> =
  /*@__PURE__*/
  messageDesc(file_profile_showcase, 15)

/**
 * @generated from enum ProfileShowcaseVisibility
 */
export enum ProfileShowcaseVisibility {
  /**
   * @generated from enum value: PROFILE_SHOWCASE_VISIBILITY_NO_ONE = 0;
   */
  NO_ONE = 0,

  /**
   * @generated from enum value: PROFILE_SHOWCASE_VISIBILITY_IDVERIFIED_CONTACTS = 1;
   */
  IDVERIFIED_CONTACTS = 1,

  /**
   * @generated from enum value: PROFILE_SHOWCASE_VISIBILITY_CONTACTS = 2;
   */
  CONTACTS = 2,

  /**
   * @generated from enum value: PROFILE_SHOWCASE_VISIBILITY_EVERYONE = 3;
   */
  EVERYONE = 3,
}

/**
 * Describes the enum ProfileShowcaseVisibility.
 */
export const ProfileShowcaseVisibilitySchema: GenEnum<ProfileShowcaseVisibility> =
  /*@__PURE__*/
  enumDesc(file_profile_showcase, 0)
